import { getId } from '@fluentui/react/lib/Utilities';

export const ROOMFINDER_OPX_VIEWSTATEID = getId('RoomPanelOpxId_');
